// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/* global window, setTimeout, clearTimeout */
/** Node.js polyfill for requestAnimationFrame */
// / <reference types="@types/node" />
export function requestAnimationFramePolyfill(callback) {
    return typeof window !== 'undefined' && window.requestAnimationFrame
        ? window.requestAnimationFrame(callback)
        : setTimeout(callback, 1000 / 60);
}
/** Node.js polyfill for cancelAnimationFrame */
export function cancelAnimationFramePolyfill(timerId) {
    return typeof window !== 'undefined' && window.cancelAnimationFrame
        ? window.cancelAnimationFrame(timerId)
        : clearTimeout(timerId);
}
//# sourceMappingURL=request-animation-frame.js.map